import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard";
import ManageRoles from "./pages/Manage Roles/ManageRoles";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoutes";
import Categories from "./pages/Categories";
import Users from "./pages/Users/Users";
import Settings from "./pages/Settings/Settings";
import AuditLogs from "./pages/Audit Logs/AuditLogs";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AuthProvider } from "./context/AuthContext";
import { DataCacheProvider } from "./context/DataCacheContext";
import CustomersRequests from "./pages/Customers Requests/CustomersRequests";

const theme = createTheme({
  palette: {
    primary: {
      main: "#006663",
    },
    secondary: {
      main: "#ff7a00",
    },
    neutral: {
      main: "#3E4944",
    },
    important: {
      main: "#0067C8",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "Inter Display",
          textTransform: "none",
          fontWeight: 500,
          borderRadius: 8,
          padding: "4px 10px 4px 10px",
          display: "flex",
          alignItems: "center",
          gap: "3px",
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
          "&:active": {
            boxShadow: "none",
          },
        },
        startIcon: {
          marginRight: "4px",
          display: "flex",
          alignItems: "center",
          transform: "translateY(-1px)",
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <DataCacheProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route
                path="/login"
                element={
                  <PublicRoute>
                    <Login />
                  </PublicRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/users"
                element={
                  <ProtectedRoute>
                    <Users />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/categories"
                element={
                  <ProtectedRoute>
                    <Categories />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/orders"
                element={
                  <ProtectedRoute>
                    <Users />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/requests"
                element={
                  <ProtectedRoute>
                    <CustomersRequests />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/manage_roles"
                element={
                  <ProtectedRoute>
                    <ManageRoles />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/audit-logs"
                element={
                  <ProtectedRoute>
                    <AuditLogs />
                  </ProtectedRoute>
                }
              />
            </Routes>

            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              closeOnClick
              pauseOnHover
              draggable
              theme="light"
            />
          </Router>
        </DataCacheProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
